<template>
  <div class="">
    <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button @click="back">返回管理页面</el-button>
      </div>
    </ZnBreadcrumb>
    <div class="main-content">
      <div class="search-type">
        <el-row :gutter="20">
          <el-col :span="6" style="width: 310px;">
            <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 300px"
                v-model="queryTime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="3" style="width: 120px;margin-left: 5px;">
            <el-select v-model="analyType" placeholder="分析维度" style="width: 120px;margin-left: 5px;">
              <el-option label="试剂维度" value="1"/>
              <el-option label="供应商维度" value="2"/>
              <el-option label="购买人维度" value="3"/>
            </el-select>
          </el-col>
          <el-col :span="1" style="margin-left: 20px;">
            <el-button size="small" type="primary" @click="dataList()" style="margin-top: 2.5px;">
              数据查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="data-info">
        <span style="font-weight: 600">购买数量</span>
        <el-divider direction="vertical"></el-divider>
        <el-row class="dataShow">
          <el-col :span="24">
            <!--试剂维度数量-->
            <el-table :data="analy.analyNumsReagent" v-show="analy.reagentNumShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '48px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名" width="100"></el-table-column>
              <el-table-column  prop="reagentName" label="试剂名称">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.reagentName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.reagentName }}</span>
                </template>
              </el-table-column>
              <el-table-column  prop="casNo" label="CAS号">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.casNo }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.casNo }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="购买数量">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.num }}件</span>
                  <span v-else style="color: #F18F41">{{ scope.row.num }}件</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--供应商维度数量-->
            <el-table :data="analy.analyNumsSupplier" v-show="analy.supplierNumShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '48px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名" width="100"></el-table-column>
              <el-table-column  prop="supplierName" label="供应商">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.supplierName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.supplierName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="购买数量">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.num }}件</span>
                  <span v-else style="color: #F18F41">{{ scope.row.num }}件</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--购买人维度数量-->
            <el-table :data="analy.analyNumsOrderUser" v-show="analy.orderUserNumShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '48px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名"  width="100"></el-table-column>
              <el-table-column  prop="orderUserName" label="购买人">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.orderUserName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.orderUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="购买数量">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.num }}件</span>
                  <span v-else style="color: #F18F41">{{ scope.row.num }}件</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>

        <div style="margin-top: 50px;">
          <span style="font-weight: 600">消费金额</span>
          <el-divider direction="vertical"></el-divider>
        </div>

        <el-row>
          <el-col :span="24">
            <!--试剂维度金额-->
            <el-table :data="analy.analyAmtsReagent" v-show="analy.reagentAmtShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '54px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名" width="100"></el-table-column>
              <el-table-column  prop="reagentName" label="试剂名称">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.reagentName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.reagentName }}</span>
                </template>
              </el-table-column>
              <el-table-column  prop="casNo" label="CAS号" >
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.casNo }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.casNo }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalAmount" label="消费金额">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.totalAmount }}元</span>
                  <span v-else style="color: #F18F41">{{ scope.row.totalAmount }}元</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--供应商维度金额-->
            <el-table :data="analy.analyAmtsSupplier" v-show="analy.supplierAmtShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '54px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名" width="100"></el-table-column>
              <el-table-column  prop="supplierName" label="供应商">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.supplierName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.supplierName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalAmount" label="消费金额">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.totalAmount }}元</span>
                  <span v-else style="color: #F18F41">{{ scope.row.totalAmount }}元</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--购买人维度金额-->
            <el-table :data="analy.analyAmtsOrderUser" v-show="analy.orderUserAmtShow" v-loading="loading" :stripe="true" style="width: 80%" :header-cell-style="{background: '#F8FAFC',color: 'rgba(0, 0, 0, 0.85)',fontWeight: 700,height: '54px'}"
                      row-key="id" border lazy :load="loadData" @row-click="getOpenDetail" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="rankId" label="排名"  width="100"></el-table-column>
              <el-table-column  prop="orderUserName" label="购买人">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.orderUserName }}</span>
                  <span v-else style="color: #F18F41">{{ scope.row.orderUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalAmount" label="消费金额">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail">{{ scope.row.totalAmount }}元</span>
                  <span v-else style="color: #F18F41">{{ scope.row.totalAmount }}元</span>
                </template>
              </el-table-column>
              <el-table-column  prop="remark" label="备注">
                <template slot-scope="scope">
                  <span v-if="0 == scope.row.isDetail"><el-link type="primary" :underline="false">{{ scope.row.remark }}</el-link></span>
                  <span v-else style="color: #F18F41">{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      queryTime: null,
      analyType: null,
      searchData: {},
      shieldedTaskId: null,
      analy: {
        analyNumsReagent: [],
        analyAmtsReagent: [],
        reagentNumShow: true,
        supplierNumShow: false,
        orderUserNumShow: false,
        reagentAmtShow: true,
        supplierAmtShow: false,
        orderUserAmtShow: false,
        analyNumsSupplier: [],
        analyAmtsSupplier: [],
        analyNumsOrderUser: [],
        analyAmtsOrderUser: []
      }
    };
  },
  created() {
  },
  methods: {
    reset() {
      this.analy = {
        analyNumsReagent: [],
        analyAmtsReagent: [],
        reagentNumShow: false,
        supplierNumShow: false,
        orderUserNumShow: false,
        reagentAmtShow: false,
        supplierAmtShow: false,
        orderUserAmtShow: false,
        analyNumsSupplier: [],
        analyAmtsSupplier: [],
        analyNumsOrderUser: [],
        analyAmtsOrderUser: []
      };
    },
    back() {
      this.$router.back();
    },
    getOpenDetail(row, column, e){
      if (e.currentTarget.firstElementChild.firstElementChild.firstElementChild.tagName == 'DIV') {
        e.currentTarget.firstElementChild.firstElementChild.firstElementChild.click();
      } else {
        e.currentTarget.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.click();
      }
    },
    dataList() {
      var startTime = null;
      var endTime = null;
      if(null == this.analyType || null == this.queryTime || this.queryTime.length == 0){
        return
      }
      this.loading = true;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      const params = this.searchData;
      params.analyType = this.analyType;
      params.startTime = startTime;
      params.endTime = endTime;
      this.$apiFetch.get(`/dataAnalyse/getData`, params).then((res) => {
        const type = params.analyType;
        this.reset();
        if(1 == type){
          this.analy.analyNumsReagent = res.data.analyNum;
          this.analy.analyAmtsReagent = res.data.analyAmt;
          this.analy.reagentNumShow = true;
          this.analy.reagentAmtShow = true;
        }
        if(2 == type){
          this.analy.analyNumsSupplier = res.data.analyNum;
          this.analy.analyAmtsSupplier = res.data.analyAmt;
          this.analy.supplierNumShow = true;
          this.analy.supplierAmtShow = true;
        }
        if(3 == type){
          this.analy.analyNumsOrderUser = res.data.analyNum;
          this.analy.analyAmtsOrderUser = res.data.analyAmt;
          this.analy.orderUserNumShow = true;
          this.analy.orderUserAmtShow = true;
        }
        this.loading = false;
      });
    },
    loadData(row, treeNode, resolve) {
      const params1 = {};
      params1.analyType =  row.analyType;
      params1.startTime = row.startTime;
      params1.endTime =  row.endTime;
      params1.dataType =  row.dataType;
      params1.casNo =  row.casNo;
      params1.rankId =  row.rankId;
      params1.supplierId =  row.supplierId;
      params1.supplierName =  row.supplierName;
      params1.orderUserName =  row.orderUserName;
      params1.isDetail =  1;
      this.$apiFetch.get(`/dataAnalyse/getDataByCasNoDetails`, params1).then((res) => {
        resolve(res.data);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}

/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;

  img.empty {
    width: 196px;
    margin-top: 38px;
  }

  button.forbid {
    color: #ff4d4f;
  }

  span.nomal {
    padding-left: 10px;
  }

  span.disabled {
    padding-left: 10px;
  }

  .nomal::before {
    width: 5px;
    height: 5px;
    background: #52c41a;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 28px;
  }

  span.disabled::before {
    background-color: #ff4d4f;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 30px;
  }
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
}

.data-info {
  padding: 20px;
  background-color: #ffffff;
}

/deep/ .right {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid #cccccc;
  display: flex;
  align-items: center;

  .el-input--suffix {
    height: 100%;
  }

  input {
    // height: 20px;
    background-color: #fff;
    border: none;
    padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  &::placeholder {
    color: #ccc;
  }
}

.requiedText {
  color: red;
}
</style>
<style lang="less">
.data-info .el-table__row el-table__row--level-1 {
  background-color: #d0d5db
}
.data-info .el-icon-arrow-right:before {
  content: "";
}
</style>
